var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSingleCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#daf2ea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10l-11 .004A2.994 2.994 0 0010.001 13v14c0 .795.317 1.56.879 2.12S12.21 30 13 30h14c.795 0 1.56-.317 2.12-.88.56-.561.879-1.33.879-2.12v-7a1 1 0 00-2 0v7a.997.997 0 01-1 1h-14a1 1 0 01-1-1V13a1 1 0 01.295-.706 1 1 0 000-.002.99.99 0 01.705-.291h11a1 1 0 000-2zm6 1a1 1 0 00-.688.301l-9.29 9.29-2.29-2.29a1 1 0 10-1.41 1.42l3 3a1 1 0 001.41 0l10-10a1 1 0 00-.727-1.72l-.006-.002z"
  })));
}

export default SvgSingleCheckbox;